export default "__VITE_ASSET__BAj$40f9__"